export enum AddressInputEnum {
  PAN = 'pan',
  PINCODE = 'pincode',
  GSTIN = 'gstin',
  EMAIL = 'email',
  SAME_SHIPPING_ADDRESS = 'sameShippingAddress',
  SAME_BILLING_ADDRESS = 'sameBillingAddress',
  PHONE = 'phone',
  OTP = 'otp',
  NAME = 'name',
  ADDRESS = 'address',
  ADDRESS2 = 'address2',
  BUSINESS_NAME = 'businessName',
  LAND_MARK = 'landmark',
  DEFAULT = 'default',
  ALTERNATE_PHONE = 'alternatePhone',
  LOCATION_TYPE_TAG = 'locationTypeTag',
  CITY = 'city',
  STATE = 'state',
}
